import React, { useMemo } from 'react';
import { TagRelationContext, TagRelationContextProps, tagRelationSlice } from '../context/TagRelationContext';
import { TagRelation } from '../types/tag/tagRelation';
import { useAppDispatch, useAppSelector } from '../ui/pages/store';

interface TagRelationProviderProps {
  children: React.ReactNode;
}

export default function TagRelationProvider({ children }: TagRelationProviderProps) {
  const dispatch = useAppDispatch();
  const items = useAppSelector(state => state.tagRelations.items);
  const loading = useAppSelector(state => state.tagRelations.loading);

  const tagRelations = useMemo(() => {
    return new Map(items.map(item => [item.id, new TagRelation(item)]));
  }, [items]);

  const tagRelationContext: TagRelationContextProps = {
    tagRelations,
    tagRelationsLoading: loading,
    setTagRelations: (tagRelations: Map<string, TagRelation>) =>
      dispatch(tagRelationSlice.actions.setAll([...tagRelations.values()])),
  };

  return <TagRelationContext.Provider value={tagRelationContext}>{children}</TagRelationContext.Provider>;
}
